import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getLanguageMessageTitle = (record, translate) =>
  `${translate("message.label")} ${record.id} (${record.code})`;

const Edit = ({ classes, ...props }) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={true}
      title={<DynamicTitleWithTooltip getTitle={getLanguageMessageTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default Edit;
